export default {"src":"/sg/_next/static/media/weddingplannerpro_inco1.bf8ae4fc.svg","height":76,"width":76,"blurWidth":0,"blurHeight":0};